module.exports = __webpack_public_path__ + "img/faq-video.9cd2f1e4.svg";